import React from 'react';
import { Stack, Typography } from '@mui/material';
import { StatusChip } from './StatusChip';

export const InfoRow = ({
  label,
  value,
  status,
}: {
  label: string;
  value: React.ReactNode;
  status?: 'success' | 'warning' | 'error';
}) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    py={1}
  >
    <Typography variant="body2" color="text.secondary">
      {label}:
    </Typography>
    <Stack direction="row" alignItems="center" spacing={1}>
      {typeof value === 'string' ? (
        <Typography variant="body2" fontWeight="medium">
          {value}
        </Typography>
      ) : (
        value
      )}
      {status && <StatusChip status={status} label="" />}
    </Stack>
  </Stack>
);
